import { AppShyComponentStyles } from "./AppShyComponent.styles";

export enum PopOverState {
  /** The component has been collapsed and is no longer visible */
  Collapsed = 0,
  /** The component has been expanded and may become shy after a user click*/
  Expanded = 1,
  /** The component has been expanded, and will dismiss on mouse leave */
  ExpandedSoftDismiss = 2,
  /** The control is no longer in a shy state and will need to be toggled back into shy mode */
  Pinned = 3,
}

export interface AppShyComponentProps {
  /**
   * Dictates the popover state of the shy component.
   */
  popOverState: PopOverState;

  /**
   * True if the application is currently in "Shy" mode. If false, the component does nothing but render the children
   */
  isActive: boolean;

  /**
   * Callback that is executed when the AppShyComponent detects a popover state change
   */
  onPopOverStateChange: (
    newState: PopOverState,
    prevState: PopOverState
  ) => void;

  /**
   * Custom styles to apply to the component. This can be used to customize the transitions or expanded/collapsed visuals
   */
  styles?: AppShyComponentStyles;

  /**
   * If set, mouseEnter and touchStart events on this element will trigger expand.
   * mouseLeave from triggerElements and shyComponent triggers collapse as long as the mouse pointer is outside both
   */
  triggerElement?: string | string[];

  /**
   * Regions outside of the shy component which should collapse the shy component when clicked in
   */
  shyDismissalRegions?: HTMLElement[];

  /**
   * Callback that is executed when the component is starting its css transition
   */
  onTransitionStart?: (ev: TransitionEvent) => void;

  /**
   * Callback that is executed when the component has ended its css transition
   */
  onTransitionEnd?: (ev: TransitionEvent) => void;
}
